import $ from 'jquery';

const OPTIN_KEY = 'LRTris'; //api public key
const OPTIN_URL = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';


export const SubscriptionFormPromise = (form) => {

  return new Promise((resolve, reject) => {

    if (!form) throw 'Invalid input';
    const email = form.find('input[type="email"]').val();
    const isOptin = form.find('input[name="promo"]:checked').length;

    let re = /\S+@\S+\.\S+/;

    if (!email || !re.test(email)) throw 'Invalid input';

    if (isOptin > 0)  {
      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: OPTIN_URL,
        data: { g: OPTIN_KEY, email: email },

        success: data => {
          try {
            if (data.success) resolve(data);
          } catch (ex) {
            return reject(ex);
          }
        },
        error: (jqXHR, status, error) => reject(error)
      });
    }
  });
}